import { SovosBox, SovosFormattedDateTime, SovosTypography } from "mosaic-react";
import { parseJson } from "../../../utils/utils";
import I18n from "../../../I18n";

export const buildGenericDetailsComponent = (cellData, i18n) => {
    const detailsKeys = Object.keys(cellData).filter((elem) =>
        ["CreatedAt", "CreatedBy"].includes(elem),
    );
    return detailsKeys.map((details, index) => {
        return (
            <SovosBox
                sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: "0.8rem 0",
                }}
                key={index}
            >
                <SovosTypography variant="h6" fontWeight="bold" children={i18n`${details}`} />
                {details === "CreatedAt" ? (
                    <SovosFormattedDateTime value={cellData[details]} />
                ) : (
                    <SovosTypography children={`${cellData[details]}`} />
                )}
            </SovosBox>
        );
    });
};

export const renderRowJson = (jsonObject) => {
    const parsedJson = parseJson(jsonObject);
    Object.entries(parsedJson).forEach(([key, value]) => {
        const newKey = key.split(".");
        const replacedKey = `${newKey?.[1] || newKey || ""}`
            .replace(/([A-Z])/g, " $1")
            .replace(/([A-Z])\s(?=[A-Z])/g, "$1");
        const translatedKey =
            key !== "CLB_ID" ? I18n.translate(replacedKey.trim().replace(/clb_ /gi, "")) : "CLB ID";
        if (translatedKey !== key) {
            parsedJson[`${translatedKey}`] = value;
            delete parsedJson[key];
        }
    });
    return (
        <SovosBox>
            <pre children={JSON.stringify({ ...parsedJson }, null, 4)} />
        </SovosBox>
    );
};
